{
  "plus": {
    "profile": {
      "twoFactorAuth": {
        "navigateBackButton": "Go back"
      }
    }
  }
}
